import { useCallback, useEffect, useState } from "react";
import api from "@/api";

export default function useSuppliers() {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchList = useCallback(async () => {
    setLoading(true);
    try {
      const res = await api.get("/suppliers");
      const list = Array.isArray(res.data) ? res.data : [];
      setData(list);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    fetchList();
  }, [fetchList]);

  const reload = useCallback(fetchList, [fetchList]);

  const create = useCallback(async (payload) => {
    // payload: { name, phone?, country?, note? }
    await api.post("/suppliers", payload);
  }, []);

  const update = useCallback(async (id, payload) => {
    setData((prev) => prev.map((x) => (x._id === id ? { ...x, ...payload } : x)));
    await api.put(`/suppliers/${id}`, payload);
  }, []);

  const remove = useCallback(async (id) => {
    await api.delete(`/suppliers/${id}`);
  }, []);

  return { data, loading, reload, create, update, remove };
}
